import { isFunction } from 'lodash';

const defaultCellDataGetter = ({ dataKey, rowData, formatter }) => {
  const value = rowData[dataKey];

  if (isFunction(formatter)) {
    return formatter(value);
  }

  return value;
};

export default defaultCellDataGetter;
